/* eslint-disable simple-import-sort/imports */
import React, {useEffect} from "react";
import { useTranslation } from "react-i18next";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import Box from "@mui/material/Box";
import { Accordion, Tooltip, Typography, styled } from "@mui/material";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import MuiAccordionSummary, { AccordionSummaryProps, } from "@mui/material/AccordionSummary";
import { DataGridPro } from "@mui/x-data-grid-pro";
import CrossSkillLegends from "../../../../cross-skilling/ui/cross-skill-header/ui/cross-skill-ledgends";
import Loading from "../../../../../../js/components/Loading";
import Highlight from "../../../../Highlight";
import Searchbar from "../../../../../design/search-bar";
import { useDataGridLocaleText } from "../../../../../design/use-datagrid-locale-text";
import useTableHeight from "../../../../../utils/use-table-height";
import useInsightSkillDetailsByLevelController from "../../../controllers/use-insight-skill-details-levels-controller";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import TextField from "@mui/material/TextField";

function SKillInsightDetailsWorkerTab({ allSkillLevels, fetchSkillInsightDetailsStatus, allLocations }: any) {

    const { t } = useTranslation();
    const [
        {
            searchText,
            searchSkillInsightDetailsData,
            expanded
        },
        {
            setSearchText,
            setExpanded
        }
    ]: any = useInsightSkillDetailsByLevelController();

    useEffect(() => {
        setSearchText("");
    }, [setSearchText, fetchSkillInsightDetailsStatus]);


    const { boxRef } = useTableHeight();
    const dataGridLocaleText = useDataGridLocaleText();

    const AccordionSummary = styled((props: AccordionSummaryProps) => (
        <MuiAccordionSummary expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />} {...props} />
    ))(({ theme }) => ({
        "&.Mui-expanded": {
            minHeight: 0,
            marginTop: 10,
            paddingRight: 0,
        },
        backgroundColor: "transparent",
        height: 30,
        flexDirection: "row-reverse",
        "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
            transform: "rotate(90deg)",
        },

        paddingLeft: 10,
    }));

    const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
        paddingLeft: 10,
        paddingRight: 10,
        width: "100%"
    }));

    const StyledAccordion = styled(Accordion)(({ theme }) => ({
        borderRadius: 0,
        boxShadow: "none",
    }));

    const columns: any = [
        {
            field: "workerName",
            headerName: t("insight-dashboard_worker-name"),
            flex: 1,
            renderCell: (params: any) => {
                const fullName = `${params?.row?.workerName}`;
                return (
                  <Tooltip title={fullName} disableInteractive>
                    <span
                      style={{
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        marginLeft: "12px",
                      }}
                    >
                      <Highlight searchText={searchText} value={fullName} />
                    </span>
                  </Tooltip>
                );
            }
        },
        { field: "locationName", headerName: t("insight-dashboard_worker-location"), flex: 1 },
        { field: "workcenterName", headerName: t("insight-dashboard_work-center"), flex: 1, align:"center", headerAlign:"center" },
    ];

    const onHandleAccordian = (level: string) => {
        setExpanded((prevExpanded: any) => {
            if (prevExpanded.includes(level)) {
                return prevExpanded.filter((accordionName: any) => accordionName !== level);
            } else {
                return [...prevExpanded, level];
            }
        });
    };

    const displayWorkersBySkillLevel = () => {

        const workersBySkillLevels: any = {}

        if (allSkillLevels !== undefined && allSkillLevels.length > 0) {

            allSkillLevels?.map((skillLevel: any) => {
                workersBySkillLevels[skillLevel.level] = []
            })

            searchSkillInsightDetailsData?.workersList?.map((worker: any, index: number) => {
                // if (allLocations.filter((location: any) => location.id === worker.locationId).length !== 0) {
                //   TODO: Removed location check not getting locationId
                // }
                workersBySkillLevels[worker.level]?.push({
                    id: index,
                    workerName: worker.workerName,
                    locationName: worker.locationName  === "" || worker.locationName === null ? "-" : worker.locationName,
                    workcenterName: worker.workcenterName === "" || worker.workcenterName === null ? "-" : worker.workcenterName
                })
            })

            // sort the workers by first name and last name
            Object.keys(workersBySkillLevels).forEach((level) => {
                workersBySkillLevels[level] = workersBySkillLevels[level].sort((a: any, b: any) =>
                    (a.workerName).localeCompare(b.workerName)
                )
            })
        }

        return (

            Object.keys(workersBySkillLevels).map((level: any) => (

                workersBySkillLevels[level].length > 0 ?

                    <Box key={level} style={{ fontWeight: "bold" }} >

                        <StyledAccordion expanded={expanded.includes(level) || searchText.length > 0} onChange={() => onHandleAccordian(`${level}`)}>

                            <AccordionSummary aria-controls={`${level}d-content`} id={`${level}-header`}>
                                <Box sx={{ display: "flex", alignItems: "center", height: 10 }}>
                                    <CrossSkillLegends isSkillLevelShownInTableHeader={true} allSkillLevels={[allSkillLevels[level]]} />
                                    <Typography style={{ fontSize: "14px" }} ml={1}>{`(${workersBySkillLevels[level].length})`}</Typography>
                                </Box>
                            </AccordionSummary>

                            <AccordionDetails >
                                {displayWorkersBySkillLevelTable(workersBySkillLevels[level])}
                            </AccordionDetails>

                        </StyledAccordion>
                    </Box>
                    : null
            ))
        )
    }

    const displayInterestedWorkers = () => {

        const rows: Array<any> = []

        // let interestedWorkersLength = 0
        searchSkillInsightDetailsData?.interestedWorkersList?.map((interestedWorker: any, index: number) => {
            // interestedWorkersLength = allLocations.filter((location: any) => location.id === interestedWorker.locationId).length
            // if (interestedWorkersLength !== 0) {
            //    TODO: Removed location check not getting locationId
            // }
            rows.push({
                id: index,
                workerName: interestedWorker.workerName,
                locationName: interestedWorker.locationName,
                workcenterName: interestedWorker.workcenterName === "" ? "-" : interestedWorker.workcenterName})
        })
        // sort the interested workers by first name and last name
        rows.sort((a: any, b: any) => (a.workerName).localeCompare(b.workerName))

        return (rows.length !== 0 &&

            <Box key={"interestedWorker"}  >
                <StyledAccordion expanded={expanded.includes("interested worker") || searchText.length > 0} onChange={() => onHandleAccordian("interested worker")}>

                    <AccordionSummary aria-controls={"interestedWorkerd-content"} id={"interestedWorker-header"}>
                        <Box sx={{ display: "flex", alignItems: "center", height: 10 }}>
                            <Typography ml={2} style={{ font: "0.9rem", fontWeight: "500" }}>{t("insight-dashboard_interested-workers")}</Typography>
                            <Typography style={{ fontSize: "14px" }} ml={1}>{`(${rows.length})`}</Typography>
                        </Box>
                    </AccordionSummary>

                    <AccordionDetails style={{ display: "grid" }}>
                        {displayWorkersBySkillLevelTable(rows)}
                    </AccordionDetails>

                </StyledAccordion>
            </Box>)
    }

    const displayWorkersBySkillLevelTable = (rows: any) => {

        return (
            <Box ref={boxRef} sx={{ width: "100%" }} >

                <DataGridPro
                    rows={rows}
                    columns={columns}
                    localeText={dataGridLocaleText}
                    disableColumnFilter
                    disableColumnMenu
                    pagination={rows.length > 5}
                    disableColumnSelector
                    disableDensitySelector
                    autoPageSize={true}
                    pageSize={5} //5 - Max number of rows
                    autoHeight={true}
                    sx={{
                        "& .MuiDataGrid-root": {
                        },
                        "& .MuiDataGrid-row": {
                            cursor: "pointer",
                        },
                        "& .MuiDataGrid-cell": {
                        },
                        "& .MuiDataGrid-columnHeader, & .MuiDataGrid-columnHeaderWrapper": {
                            backgroundColor: "rgba(0, 0, 0, 0.04)"
                        },
                        "& .MuiDataGrid-columnHeader:last-of-type": {
                            borderRight: "none",
                        },
                        "& .MuiDataGrid-cell:last-of-type": {
                            borderRight: "none",
                        },
                        overflow: "hidden",
                        border: "none !important",
                    }}
                />
            </Box>
        )
    }

    return (

        fetchSkillInsightDetailsStatus !== "pending" ?

            <Box
                sx={{
                    width: "100%",
                    paddingTop: "10px",
                }}
            >
                <Box sx={{ padding: "8px 16px", width: "100%" }}>
                    {(searchSkillInsightDetailsData?.interestedWorkersList?.length > 0 || searchSkillInsightDetailsData?.workersList?.length > 0 || searchText.length > 0) &&
                        <TextField
                            label={t("common_search")}
                            placeholder=""
                            fullWidth
                            variant="filled"
                            onChange={(e) =>
                                setSearchText(e.target.value.toLowerCase())
                            }
                            size="small"
                            value={searchText}
                            slotProps={{
                                input: {
                                    endAdornment: searchText !== undefined &&
                                        searchText.length > 0 && (
                                            <CancelOutlinedIcon
                                                sx={{ cursor: "pointer", color: "#92918f" }}
                                                onClick={() => setSearchText("")}
                                            />
                                        ),
                                },
                            }}
                            sx={{
                                "& .MuiFilledInput-underline:before": {
                                    borderBottom: "none",
                                },
                                "& .MuiFilledInput-underline:after": {
                                    borderBottom: "none",
                                },
                                //paddingTop: "4px",
                                marginBottom: "16px",
                                // marginLeft: "24px",
                            }}
                        />
                    }
                    {(searchSkillInsightDetailsData?.interestedWorkersList?.length > 0 || searchSkillInsightDetailsData?.workersList?.length > 0) ?
                        <>
                            {displayWorkersBySkillLevel()}

                            {displayInterestedWorkers()}
                        </>
                        :
                        <Box sx={{ alignItems: "center", display: "flex", flexDirection: "column", mt: 10 }}>
                            <PersonOffIcon sx={{ color: "#6c6d6e", fontSize: "40px" }} />
                            {searchText.length > 0 ? t("insight-dashboard_no-workers-found") : t("insight-dashboard_no-workers-found-for-skill")}
                        </Box>
                    }
                </Box>
            </Box>
            : <Loading />
    )
}

export default SKillInsightDetailsWorkerTab